// Source system configurations
export const SOURCE_SYSTEMS = [
  {
    id: 'HORUS',
    name: 'Horus',
    description: 'Cloud-based accounting software',
    icon: 'cloud'
  },
  {
    id: 'WINBOOKS',
    name: 'Winbooks',
    description: 'Professional accounting solution',
    icon: 'calculate'
  },
  {
    id: 'SAGE_BOB_50',
    name: 'Sage BOB 50',
    description: 'SMB accounting software',
    icon: 'description'
  }
]

// Destination system configurations (Odoo versions) - kept for reference/display
export const DESTINATION_SYSTEMS = [
  {
    id: 'ODOO_18',
    name: 'Odoo 18',
    description: 'Latest stable release',
    icon: 'inventory_2'
  },
  {
    id: 'ODOO_19',
    name: 'Odoo 19',
    description: 'Newest version',
    icon: 'rocket_launch'
  }
]
